module.exports = __webpack_public_path__ + "img/tab3.426ab6d6.png";